module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('EnquiryOnlineConfigForm', {
    ref: "popForm",
    on: {
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Configuration management")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2e734029","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/product/EnquiryOnlineConfigManagement.vue
// module id = 750
// module chunks = 1